<template>
  <div v-show="isActive">
    <div class="tab-pane">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        isActive: false
      }
    },
    mounted: function () {
      this.isActive = this.selected;
    },
    created: function () {
      this.anchors = this.$parent.children;
    },
    props: {
      name: { required: true },
      tabName: { type: String },
      isValid: { type: Boolean },
      icon: { required: true },
      selected: { default: false }
    },
    computed: {
      href: function () {
        return '#' + this.name.toLowerCase().replace(/ /g, '-');
      }
    },
    watch: {
      tabName: function() {
        this.isActive = (this.name == this.tabName);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/shared/Tab.vue